import { Fragment, useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import API from "../../api/axiosConfig";

export default function PendingReimbursementList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [reimbursements, setReimbursements] = useState([]);

  const getPendingReimbursements = async () => {
    setLoading(true);
    try {
      const response = await API.post("api/reimbursements/pending");
      setReimbursements(response.data);
    } catch (error) {
      console.log("Error fetching user's pending reimbursements!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPendingReimbursements();
  }, []);


  return (
    <Box sx={{ width: "100%", boxSizing: "border-box" }}>
      <Typography
        variant="h6"
        fontWeight="700"
        sx={(theme) => ({
          mb: 3,
          textAlign: "left",
          color: theme.palette.paper.light,
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 1
        })}
      >
        Pending Reimbursements
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : reimbursements.length > 0 ? (
        <Stack spacing={3} sx={{ width: "100%" }}>
          {reimbursements.map((reimburse, index) => (
            <Fragment key={reimburse.id}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  p: 2,
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1fr 1fr auto" },
                    gap: 3,
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {/* DESCRIPTION COLUMN */}
                  <Box sx={{ minWidth: 0, textAlign: "left" }}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: "block", mb: 0.5, textTransform: "uppercase" }}>
                      Description
                    </Typography>
                    <Typography variant="body2" color="text.primary" sx={{ wordBreak: "break-word" }}>
                      {reimburse.reason}
                    </Typography>
                  </Box>

                  {/* AMOUNT COLUMN */}
                  <Box sx={{ minWidth: 0, textAlign: "left" }}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: "block", mb: 0.5, textTransform: "uppercase" }}>
                      Amount
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "700", color: "success.main" }}
                    >
                      ${reimburse.amount.toFixed(2)}
                    </Typography>
                  </Box>

                  {/* ACTION COLUMN (VIEW DETAILS) */}
                  <Box 
                    sx={{ 
                      width: "100%", 
                      minWidth: { lg: "120px" }, 
                      display: "flex", 
                      justifyContent: { xs: "flex-start", lg: "flex-end" } 
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => navigate(`/reimbursements/${reimburse.id}`)}
                      sx={{
                        width: { xs: "100%", lg: "auto" },
                        height: "40px",
                        color: "#90caf9",
                        borderColor: "#90caf9",
                        textTransform: "none",
                        fontWeight: "600",
                        px: 3,
                        borderRadius: 1
                      }}
                    >
                      View
                    </Button>
                  </Box>
                </Box>
              </Box>

              {index < reimbursements.length - 1 && (
                <Divider sx={{ my: 1 }} />
              )}
            </Fragment>
          ))}
        </Stack>
      ) : (
        <Typography
          variant="body2"
          sx={(theme) => ({
            textAlign: "center",
            fontStyle: "italic",
            color: theme.palette.paper.verylight,
            py: 2
          })}
        >
          No pending reimbursements found.
        </Typography>
      )}
    </Box>
  );
}
